import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from "@mui/material";

/**
 * 확인 다이얼로그에 대한 Props 속성
 *
 * @type ConfirmProps
 */
type ConfirmProps = Omit<DialogProps, "maxWidth" | "fullWidth"> & {
  /**
   * 제목
   */
  title: string;
  /**
   * 내용
   */
  content: string | React.ReactNode;
  /**
   * '확인' 버튼의 문구 변경
   * @default '확인'
   */
  okTitle?: string;
  /**
   * '확인' 버튼 클릭 시 콜백 함수
   * @returns
   */
  onOk: () => void;
  /**
   * '취소' 버튼 클릭 시 콜백 함수
   */
  cancelTitle?: string;
  /**
   * '취소' 버튼 클릭 시 콜백 함수
   * @returns
   */
  onCancel?: () => void;
};

/**
 * 확인 다이얼로그
 *
 * @param props
 * @returns
 */
export const Confirm = (props: ConfirmProps) => {
  const {
    title,
    content,
    okTitle = "확인",
    cancelTitle = "취소",
    onOk,
    onCancel,
    ...other
  } = props;

  return (
    <Dialog {...other} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onCancel}>
          {cancelTitle}
        </Button>
        <Button variant="contained" color="primary" onClick={onOk}>
          {okTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
